export const miscActivityGroups = {
    CURRENT: 0,
    RETROSPECTIVE: 1,
    DRAFTING: 2,
};
